"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.type17Fields = void 0;
exports.type17Fields = {
    LogicalRecordLengthT17: {
        label: 'Logical Record Length',
        minLength: 3,
        maxLength: 7,
        required: false,
        desc: 'This mandatory field shall contain the length of  the logical record specifying the total number of  bytes, including every byte of all nine fields  contained in the record.',
        EBTS: {
            mnemonic: 'T17_LEN',
            index: '17.001',
            dataType: 'N'
        }
    },
    ImageDesignationCharacterT17: {
        label: 'Image Designation Character',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: 'This mandatory  field shall be used to identify the  image data contained in this record. The IDC in this  field shall be a binary representation of the IDC  found in the file content field of the Type 1 record.',
        EBTS: {
            mnemonic: 'T17_IDC',
            index: '17.002',
            dataType: 'N'
        }
    },
    FeatureIdentifier: {
        label: 'Feature Identifier',
        minLength: 1,
        maxLength: 1,
        required: false,
        options: [
            ['0', 'Left or right eye not defined'],
            ['1', 'Right Eye'],
            ['2', 'Left Eye']
        ],
        desc: ' This mandatory field shall contain an identifer for which eye  is represented by the image in the record.   An entry of 0 in this field indicates that the image in  this record is undefined.  An entry of 1 in this field indicates that the image in this record is of a right eye.  An entry of 2 in this field indicates that the image in  this record is of a left eye.',
        EBTS: {
            mnemonic: 'T17_FID',
            index: '17.003',
            dataType: 'N'
        }
    },
    SourceAgencyORIT17: {
        label: 'Source Agency / ORI',
        minLength: 9,
        maxLength: 20,
        desc: 'This is a mandatory field which identifies the  organization that originally captured the image  contained in the record. Normally the Originating  Agency Identifier (ORI) of the agency that captured  the image will be contained in this field.',
        EBTS: {
            mnemonic: 'T17_SRC',
            index: '17.004',
            dataType: 'AN'
        },
        required: false
    },
    IrisCaptureDate: {
        label: 'Iris Capture Date',
        minLength: 8,
        maxLength: 8,
        desc: 'This mandatory ASCII field shall contain the date  that the iris image contained in the record was  captured. The date shall appear as an eight number  in the format CCYYMMDD. The complete date must be a  legitimate date and shall not exceed the current date.',
        EBTS: {
            mnemonic: 'T17_ICD',
            index: '17.005',
            dataType: 'N'
        },
        required: false
    },
    HorizontalLineLengthT17: {
        label: 'Horizontal Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory field shall contain the number of pixels  present on a single horizontal line of the transmitted image.',
        EBTS: {
            mnemonic: 'T17_HLL',
            index: '17.006',
            dataType: 'N'
        }
    },
    VerticalLineLengthT17: {
        label: 'Vertical Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory field shall contain the number of pixels  present on a single horizontal line of the transmitted image.',
        EBTS: {
            mnemonic: 'T17_VLL',
            index: '17.007',
            dataType: 'N'
        }
    },
    ScaleUnitsT17: {
        label: 'Scale Units',
        minLength: 1,
        maxLength: 1,
        required: false,
        desc: 'This mandatory ASCII filed shall specify the units used to  describe the image sampling frequency(pixel density).  A \\"1\\" in  this field indicates pixels per inch, or a \\"2\\" indicates pixel  per centimenter.  A \\"0\\" indicates no scale is given.  For this case,  the quotient of HPS/VPS givels the pixel aspect ratio.',
        EBTS: {
            mnemonic: 'T17_SLC',
            index: '17.008',
            dataType: 'N'
        }
    },
    HorizontalPixelScaleT17: {
        label: 'Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall specify the integer  pixel density used in the horizontal direction  providing the SLC contains a \\"1\\" or a \\"2\\". Otherwise,  it indicates the horizontal component of the  pixel aspect ratio.',
        EBTS: {
            mnemonic: 'T17_HPS',
            index: '17.009',
            dataType: 'N'
        }
    },
    VerticalPixelScaleT17: {
        label: 'Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall specify the integer  pixel density used in the vertical direction providing  the SLC contains a \\"1\\" or a \\"2\\". Otherwise,  it indicates the vertical component of the pixel  aspect ratio.',
        EBTS: {
            mnemonic: 'T17_VPS',
            index: '17.010',
            dataType: 'N'
        }
    },
    CompressionAlgorithmT17: {
        label: 'Compression Algorithm',
        minLength: 4,
        maxLength: 6,
        required: false,
        options: [
            ['NONE', 'Uncompressed'],
            ['JPEGB', 'JPEG']
        ],
        desc: 'This mandatory ASCII field shall specify the algorithm used to compress the image.  an entry of \\"NONE\\" indicates that the data  contained in the record is uncompressed.  The domain registrar,  DoD Biometrics, maintains a  registry of acceptable compression  techniques and and coresponding codes.',
        EBTS: {
            mnemonic: 'T17_CGA',
            index: '17.011',
            dataType: 'AN'
        }
    },
    BitsPerPixelT17: {
        label: 'Bits Per Pixel',
        minLength: 1,
        maxLength: 2,
        required: false,
        options: [
            ['8', 'Normal Grayscale'],
            ['24', 'Normal RGB']
        ],
        desc: 'This mandatory field shall contain the number of bits used to represent a pixel.  This field shall contain an  entry of 8 for normal grayscale values of 0 to 255  or an entry of 24 for normal RGB color values of any  combination of red, green, and blue values.',
        EBTS: {
            mnemonic: 'T17_BPX',
            index: '17.012',
            dataType: 'N'
        }
    },
    ColorSpaceT17: {
        label: 'Color Space',
        minLength: 3,
        maxLength: 4,
        options: [
            ['YCC', 'JPEG and JFIF Color Space'],
            ['GRAY', 'Grayscale Images'],
            ['RGB', 'Uncompressed Color Image']
        ],
        desc: "This is a mandatory field which specifies the color  space used to exchange the image. For compressed  images, the preferred color space using JPEG and  JFIF is YCbCr indicated by 'YCC'. An entry of 'GRAY'  should be used for all grayscale images. This field  shall contain 'RGB' for uncompressed color images  which contain non-interleaved red, green, and blue  pixels in that order.",
        EBTS: {
            mnemonic: 'T17_CSP',
            index: '17.013',
            dataType: 'A'
        },
        required: false
    },
    ImageQualityScore: {
        label: 'Image Quality Score',
        type: 'header',
        minLength: 6,
        maxLength: 35,
        minOccurrences: 0,
        desc: "This optional field specifies the quality score data  for the iris image stored in this record. Contains sub-fields  which we'll get to when we know the following: Registered vendor  ID of the quality algorithm and the numeric product code assigned  to the algorithm by its vendor.",
        EBTS: {
            mnemonic: 'T17_IQS',
            index: '17.024:',
            dataType: 'ANS'
        },
        subFields: {
            fields: {
                QualityScore: {
                    label: 'Quality Score',
                    minLength: 1,
                    maxLength: 3,
                    required: false,
                    EBTS: {
                        mnemonic: 'T17_IQS_SCOR',
                        index: '17.024..1',
                        dataType: 'N'
                    }
                },
                AlgorithmVendor: {
                    label: 'Algorithm Vendor',
                    minLength: 4,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T17_IQS_VNDR',
                        index: '17.024..2',
                        dataType: 'AN'
                    }
                },
                AlgorithmVersion: {
                    label: 'Algorithm Version',
                    minLength: 1,
                    maxLength: 3,
                    required: false,
                    EBTS: {
                        mnemonic: 'T17_IQS_VRSN',
                        index: '17.024..3',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    DamagedOrMissingEye: {
        label: 'Damaged Or Missing Eye',
        minLength: 2,
        maxLength: 2,
        options: [
            ['MA', 'Missing/Amputated'],
            ['UC', 'Unable to Capture']
        ],
        EBTS: {
            mnemonic: 'T17_DME',
            index: '17.028',
            dataType: 'A'
        },
        required: false
    },
    IrisImage: {
        label: 'Iris Image',
        minLength: 1,
        required: false,
        desc: 'This field contains the Iris image data.',
        EBTS: {
            mnemonic: 'T17_DAT',
            index: '17.999',
            dataType: 'B1'
        }
    }
};
//# sourceMappingURL=jfd.type17.js.map